module.exports = __webpack_public_path__ + "img/store_fromHome.dbfad8a1.jpg";